import React from "react";
import { Form, Well, Row, Col, Button } from "react-bootstrap";

import { FsCheckbox } from "shared/components/fs";

const LoadingButton = (
  <div>
    <span className="glyphicon glyphicon-refresh spinning" /> Laden...
  </div>
);

export default class TosForm extends React.PureComponent {
  render() {
    const { props } = this;
    const { formState, isLoading } = props;
    if (!formState) {
      return null;
    }

    const tosLabel = (
      <span>
        Ich akzeptiere die{" "}
        <a href={props.tosUrl} target="_blank" rel="noopener noreferrer">
          Allgemeinen Geschäftsbedingungen (AGB)
        </a>
        .
      </span>
    );

    const privacyStatementLabel = (
      <span>
        Ich akzeptiere die{" "}
        <a href={props.privacyUrl} target="_blank" rel="noopener noreferrer">
          Datenschutzbestimmungen
        </a>
        .
      </span>
    );

    const subscribedNewsletterLabel = (
      <span>
        Newsletter abonnieren <br />
        <span className="font-weight-normal">
          Verpasse keine EDEKA StartHub Events mehr und erhalte als erster News aus
          der EDEKA Community.
        </span>
      </span>
    );

    return (
      <Form horizontal>
        <h2>Worauf wartest Du?</h2>

        <Well>
          <p>
            Mit Abschluss der Registrierung auf EDEKA StartHub erhältst Du Zugang
            zu einem kostenfreien Paket:
          </p>

          <strong>Guide</strong>
          <p>
            Erhalte relevantes Branchenwissen, wichtige Handelskennzahlen und
            eine Checkliste für den erfolgreichen Auftritt auf EDEKA StartHub.
          </p>

          <strong>Persönlicher Ansprechpartner</strong>
          <p>
            Das EDEKA StartHub Team ist persönlich an fünf Tagen pro Woche für Dich
            da. Wir klären Deine Fragen und Anliegen per Telefon oder Email.
          </p>

          <strong>EDEKA StartHub Community</strong>
          <p>
            Lese Erfahrungsberichte von Startups und Kaufleuten. Erhalte zudem
            Infos und Neuigkeiten zu EDEKA StartHub Events sowie zur Plattform.
          </p>

          <p>
            Nach der Registrierung erhältst Du die Möglichkeit gegen eine
            Gebühr, Deine Produkte über 800 EDEKA StartHub Kaufleuten zum Verkauf
            anzubieten. Weitere Informationen findest Du in den{" "}
            <a
              href={this.props.tosUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Allgemeinen Geschäftsbedingungen
            </a>
            .
          </p>
        </Well>

        <FsCheckbox
          formState={props.formState}
          attribute="tos_accepted"
          label={tosLabel}
          labelColumnCount={10}
          inputColumnCount={1}
        />

        <FsCheckbox
          formState={props.formState}
          attribute="privacy_statement_accepted"
          label={privacyStatementLabel}
          labelColumnCount={10}
          inputColumnCount={1}
        />

        <FsCheckbox
          formState={props.formState}
          attribute="subscribed_newsletter"
          label={subscribedNewsletterLabel}
          labelColumnCount={10}
          inputColumnCount={1}
        />

        <Row>
          <Col sm={3}>
            <Button className="btn btn-secondary" onClick={props.cancelFn}>
              Zurück
            </Button>
          </Col>
          <Col sm={9}>
            <Button
              className="btn btn-secondary pull-right"
              onClick={!isLoading ? props.submitFn : null}
            >
              {isLoading ? LoadingButton : "JETZT REGISTRIEREN"}
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}
